import { render, staticRenderFns } from "./PasscodeConfirmationStep.vue?vue&type=template&id=a3771996&scoped=true&"
import script from "./PasscodeConfirmationStep.vue?vue&type=script&lang=js&"
export * from "./PasscodeConfirmationStep.vue?vue&type=script&lang=js&"
import style0 from "./PasscodeConfirmationStep.vue?vue&type=style&index=0&id=a3771996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3771996",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3769141042/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3771996')) {
      api.createRecord('a3771996', component.options)
    } else {
      api.reload('a3771996', component.options)
    }
    module.hot.accept("./PasscodeConfirmationStep.vue?vue&type=template&id=a3771996&scoped=true&", function () {
      api.rerender('a3771996', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/ring/PasscodeConfirmationStep.vue"
export default component.exports